import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Spinner, Alert } from 'react-bootstrap'; 
import NavBar2 from '../components/Navbar2/NavBar2.js';
import Catalogues from '../components/Catalogues.js'; 
import CategoriesNavbar from '../components/CategoriesNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

const Accueil = () => {
  const styles = {
    AccueilPage: {
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      overflowX: 'hidden',
    },
    navbar: {
      position: 'fixed',
      top: '0',
      width: '100%',
      zIndex: '1000',
      backgroundColor: '#fff',
    },
    sidebar: {
      position: 'fixed',
      top: '120px',
      left: '0',
      width: '20%',
      height: '100%',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      zIndex: '998',
      overflowY: 'auto',
      boxShadow: '1px 2px 9px 0 gray',
    },
    productArea: {
      marginLeft: '20%',
      marginTop: '120px',
    },
  };

  const [products, setProducts] = useState([]); // Tous les produits
  const [filteredProducts, setFilteredProducts] = useState([]); // Produits filtrés
  const [selectedCategory, setSelectedCategory] = useState(''); // Catégorie sélectionnée
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fonction pour récupérer les produits depuis le backend
  const fetchProducts = () => {
    axios
      .get('http://localhost:5000/api/products/products')
      .then((response) => {
        console.log('Produits récupérés :', response.data.products);
        setProducts(response.data.products); // Stocker tous les produits
        setFilteredProducts(response.data.products); // Initialiser avec tous les produits
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des produits:', error);
        setError('Une erreur est survenue lors de la récupération des produits.');
        setLoading(false);
      });
  };

  // Appliquer le filtre à chaque fois que `selectedCategory` change
  useEffect(() => {
    if (selectedCategory === '') {
      setFilteredProducts(products); // Afficher tous les produits si aucune catégorie n'est sélectionnée
    } else {
      const filtered = products.filter(
        (product) => product.category === selectedCategory
      );
      setFilteredProducts(filtered);
    }
  }, [selectedCategory, products]);

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div style={styles.AccueilPage}>
      <div style={styles.navbar}>
        <NavBar2 />
      </div>
      {/* Passer la fonction de sélection de catégorie */}
      <CategoriesNavbar onCategorySelect={setSelectedCategory} />
      <Container fluid>
        <Row>
          <Col lg={3} style={styles.sidebar}>
            <h2 style={styles.heading}>Catégories</h2>
            {/* Ajouter des cases à cocher pour les catégories si besoin */}
            <Form.Check type="checkbox" label="Vêtements" />
            <Form.Check type="checkbox" label="Cuisine" />
            <Form.Check type="checkbox" label="Electronique" />
            <Form.Check type="checkbox" label="Soins et Beauté" />
            <Form.Check type="checkbox" label="Téléphones Portables" />
            <Form.Check type="checkbox" label="Maison et Bureau" />
          </Col>

          <Col lg={9} style={styles.productArea}>
            <Row>
              {loading ? (
                <div style={{ textAlign: 'center' }}>
                  <Spinner animation="border" variant="primary" />
                  <p>Chargement des produits...</p>
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <Catalogues key={product.id} product={product} />
                ))
              ) : (
                <p>Aucun produit trouvé pour cette catégorie.</p>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Accueil;
